import { Color } from "./colors";

export const computeColor = (
  color: Color,
  prefix?: "bg" | "text" | "fill" | "stroke"
) => {
  switch (prefix) {
    case "bg":
      return computeBg(color);
    case "text":
      return computeText(color);
    case "fill":
      return computeFill(color);
    case "stroke":
      return computeStroke(color);
    default:
      return computeBg(color);
  }
};

const computeBg = (color: Color) => {
  switch (color) {
    case "primary":
      return "bg-primary";
    case "secondary":
      return "bg-secondary";
    case "tertiary":
      return "bg-tertiary";
    case "success":
      return "bg-success";
    case "warning":
      return "bg-warning";
    case "error":
      return "bg-error";
    case "loading":
      return "bg-loading";
    case "blue":
      return "bg-blue";
    case "lightblue":
      return "bg-lightblue";
    case "orange":
      return "bg-orange";
    case "purple":
      return "bg-purple";
    case "indaco":
      return "bg-indaco";
    case "white":
      return "bg-white";
    case "black":
      return "bg-black";
    case "grey":
      return "bg-grey";
  }
};

const computeText = (color: Color) => {
  switch (color) {
    case "primary":
      return "text-primary";
    case "secondary":
      return "text-secondary";
    case "tertiary":
      return "text-tertiary";
    case "success":
      return "text-success";
    case "warning":
      return "text-warning";
    case "error":
      return "text-error";
    case "loading":
      return "text-loading";
    case "blue":
      return "text-blue";
    case "lightblue":
      return "text-lightblue";
    case "orange":
      return "text-orange";
    case "purple":
      return "text-purple";
    case "indaco":
      return "text-indaco";
    case "white":
      return "text-white";
    case "black":
      return "text-black";
    case "grey":
      return "text-grey";
  }
};

const computeFill = (color: Color) => {
  switch (color) {
    case "primary":
      return "fill-primary";
    case "secondary":
      return "fill-secondary";
    case "tertiary":
      return "fill-tertiary";
    case "success":
      return "fill-success";
    case "warning":
      return "fill-warning";
    case "error":
      return "fill-error";
    case "loading":
      return "fill-loading";
    case "blue":
      return "fill-blue";
    case "lightblue":
      return "fill-lightblue";
    case "orange":
      return "fill-orange";
    case "purple":
      return "fill-purple";
    case "indaco":
      return "fill-indaco";
    case "white":
      return "fill-white";
    case "black":
      return "fill-black";
    case "grey":
      return "fill-grey";
  }
};

const computeStroke = (color: Color) => {
  switch (color) {
    case "primary":
      return "stroke-primary";
    case "secondary":
      return "stroke-secondary";
    case "tertiary":
      return "stroke-tertiary";
    case "success":
      return "stroke-success";
    case "warning":
      return "stroke-warning";
    case "error":
      return "stroke-error";
    case "loading":
      return "stroke-loading";
    case "blue":
      return "stroke-blue";
    case "lightblue":
      return "stroke-lightblue";
    case "orange":
      return "stroke-orange";
    case "purple":
      return "stroke-purple";
    case "indaco":
      return "stroke-indaco";
    case "white":
      return "stroke-white";
    case "black":
      return "stroke-black";
    case "grey":
      return "stroke-grey";
  }
};
